import * as yup from 'yup';

import { leistungsumfangSchema } from '@/features/Sparten/res/schema/leistungsumfangSchema/leistungsumfangSchema';

export const resSchema = yup.object({
  vorschaden: yup.string().default('').required(),
  demvRabattiert: yup.boolean().default(true),
  laufzeit: yup.string().default(''),
  selbstbeteiligung: yup.string().required().default(''),
  tarifgruppe: yup.string().default(''),
  berufsstatus: yup.string().default(''),
  leistungsumfang: leistungsumfangSchema,
});
